import IconNameEnum from "constants/IconNameEnum";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BaseBreadcrumb from "../base-breadcrumb/BaseBreadcrumb";
import LoadingIndicator from "../loading-indicator/LoadingIndicator";
import BaseCard from "./BaseCard";

interface IProps {
    isRequesting?: boolean;
    headerIcon?: IconNameEnum;
    headerTitle?: string;
    headerActions?: JSX.Element;
    headerActionsLeft?: JSX.Element;
    footerActionsRight?: JSX.Element;
    footerActionsLeft?: JSX.Element;
    breadcrumbLevel?: number;
    breadcrumbLabels?: { [key: string]: string }[];
    isIE?: boolean;
    isSafari?: boolean;
    headerIconClassName?: string;
    headerTitleClassName?: string;
    breadcrumbGoLevel1?: () => void;
    breadcrumbGoLevel2?: () => void;
    breadcrumbGoLevel3?: () => void;
    headerSubtitle?: string;
}

class BasePageCard extends React.Component<IProps> {
    public render(): JSX.Element {
        const {
            isRequesting,
            headerIcon,
            headerTitle,
            headerActions,
            headerActionsLeft,
            footerActionsRight,
            footerActionsLeft,
            breadcrumbLevel,
            breadcrumbLabels,
            breadcrumbGoLevel1,
            breadcrumbGoLevel2,
            breadcrumbGoLevel3,
            isIE,
            isSafari,
            headerIconClassName,
            headerTitleClassName,
            headerSubtitle,
        } = this.props;

        return (
            <LoadingIndicator className="h-100" isActive={isRequesting}>
                <Container fluid className="h-100">
                    <Row className={`${isIE || isSafari ? "" : "h-100"}`}>
                        <Col>
                            <BaseCard
                                headerIcon={headerIcon}
                                headerTitle={headerTitle}
                                headerActions={headerActions}
                                footerActionsRight={footerActionsRight}
                                footerActionsLeft={footerActionsLeft}
                                headerActionsLeft={headerActionsLeft}
                                isIE={isIE}
                                isSafari={isSafari}
                                fullWidthActions={isIE || isSafari}
                                headerIconClassName={headerIconClassName}
                                headerClassName={headerTitleClassName}
                                headerSubtitle={headerSubtitle}
                            >
                                {breadcrumbLabels && (
                                    <BaseBreadcrumb
                                        level={breadcrumbLevel}
                                        labels={breadcrumbLabels}
                                        goLevel1={breadcrumbGoLevel1}
                                        goLevel2={breadcrumbGoLevel2}
                                        goLevel3={breadcrumbGoLevel3}
                                    />
                                )}
                                {this.props.children}
                            </BaseCard>
                        </Col>
                    </Row>
                </Container>
            </LoadingIndicator>
        );
    }
}

export { BasePageCard as Unconnected };
export default BasePageCard;
